export interface ISwitchModel {
    enabled: boolean;
    text: string;
}

export class SwitchModel implements ISwitchModel {
    enabled: boolean;
    text: string;
    constructor(enabled?:boolean, text?:string) {
        this.enabled = enabled;
        this.text = text;
    }
}
